import API from '@/API/request';

export const templateActivityApi = {
  // 新增
  templateActivityAdd: (params) => API.post(`/template_activity/add`, params),
  // 删除
  templateActivityDel: (params) => API.delete(`/template_activity/del/${params}`),
  // 修改
  templateActivityUpdate: (params) => API.post('/template_activity/update', params),
  // 获取ticketEncrypt
  getTicketEncrypt: () => API.get(`/ht/ticketEncrypt`)
};

export const hqActivityManagementApi = {
  // 新增
  hqActivityAdd: (params) => API.post(`/headquarter_activity/add`, params),
  // 删除
  hqActivityDel: (params) => API.delete(`/headquarter_activity/del/${params}`),
  // 修改
  hqActivityUpdate: (params) => API.post('/headquarter_activity/update', params)
};

export const budgetPerformanceApi = {
  // 获取费用类型列表
  getExpenseTypeList: () => API.get(`/expense_relate/expense_type_list`),
  // 获取申请部门和费用归属部门 type: APPLAY(申请部门)  EXPENSE(费用归属部门)
  getBudgetExpenseDeptList: (params) => API.get(`/expense_relate/budget/expense_dept_list`),
  // 获取预算执行情况
  getBudgetImplementation: (params) => API.post(`/expense_relate/budget/implementation`, params),
  // 获取详情页数据
  getBudgetDetailsData: (params) => API.post(`/expense_relate/budget/implementation/details`, params),
  // 获取详情页数据
  budgetAdjustment: (params) => API.post(`/expense_relate/budget/implementation/adjustment`, params),
  // 获取部门列表
  getDeptNameList: (params) => API.get(`/expense_relate/budget/dept/${params.deptName}/${params.expenseTypeCode}`),
  // 费用部门调整
  setExpenseDept: (params) => API.put(`/expense_relate/budget/expense-dept`, params),
  // 能否核销
  setSpecialWriteOff: (params) => API.put(`/expense_relate/special-write-off/${params.expenseBelongId}/${params.ifSpecialWriteOff}`)
};

export const budgetPerformancePermissionApi = {
  // 获取部门列表
  getDeptNameList: () => API.get(`/expense_config/exp_dept_list`),
  // 查看人列表
  getAllSalesmanList: (params) => API.get(`/config/salesman/all-list/20/${params}`),
  // 查询预算执行情况权限列表
  getBudgetPerformancePermissionList: (params) => API.post(`/budget-performance-permission/queryList`, params),
  // 查询预算执行情况权限详情，用于编辑页回显
  getBudgetPerformancePermissionDetail: (params) => API.get(`/budget-performance-permission/detail/${typeof params === 'object' ? params.id : params}`),
  // 新增预算执行情况权限
  addBudgetPerformancePermission: (params) => API.post(`/budget-performance-permission/add`, params),
  // 编辑预算执行情况权限
  editBudgetPerformancePermission: (params) => API.post(`/budget-performance-permission/update`, params),
  // 删除预算执行情况权限
  deleteBudgetPerformancePermission: (params) => API.post(`/budget-performance-permission/delete`, params)
};

export const activityBaseApi = {
  // 活动基地新增
  getActivityBase: (params) => API.post(`/activity-base/`, params),
  // 获取活动基地列表
  getActivityBaseList: (params) => API.post(`/activity-base/list`, params),
  // 活动基地修改
  setActivityBase: (params) => API.put(`/activity-base/`, params),
  // 活动基地删除
  delActivityBase: (params) => API.delete(`/activity-base/${params}`),
  // 活动基地状态修改
  setActivityBaseStatus: (params) => API.put(`/activity-base/${params.id}/${params.stat}`),
  // 获取活动基地详
  getActivityBaseDetail: (params) => API.get(`/activity-base/detail/${params.id}`),
  // 获取活动基地列表
  getConfigActivityBaseList: (params) => API.get(`/config/activity-base/${params.deptCode}`)
};

export const expensesJurManagementApi = {
  // 获取费用归属部门列表
  getExpenseDeptList: () => API.get('/expense_config/exp_dept_list'),
  // 获取申请部门列表
  getApplyDeptList: () => API.get('/expense_config/apply_dept_list'),
  // 获取分级部门列表  首次000 表示请求1级部门code
  getAllDeptList: (params) => API.get(`/expense_config/all_dept/${params}`),
  // 新增费用权限
  addExpenseJur: (params) => API.post('/expense_config/add_expense_config', params),
  // 删除
  delExpenseJur: (params) => API.delete(`/expense_config/del_exp_config_user/${params}`)
};

export const approvalManagementApi = {
  // 新增
  addApproveUser: (params) => API.post('/approveuser/add', params),
  // 编辑
  editApproveUser: (params) => API.put('/approveuser/update', params),
  // 删除
  deleteApproveUser: ({ id, type }) => API.delete(`/approveuser/del/${id}/${type}`),
  // 获取审批人列表
  getApprovedList: (params) => API.get(`/config/salesman/all_list/10/${params}`),
  // 后台管理-审批人管理-获取审批人列表
  getApproveUserList: (params) => API.get(`/config/approve_user?param=${params}`),
  // 归属部门
  getDeptList: (params) => API.get(`/config/dept/list/${params.type}/${params.key}`)
};

export const transferOrderApi = {
  // 列表查询
  getTransferOrderList: (params) => API.post('/activity/activity_list', params),
  // 移交申请人
  approveUserTransfer: (params) => API.put('/approvecenter/transfer', params),
  // 审批详情
  approveDetails: (params) => API.get(`/approvecenter/task_list/${params.id}`, { params: { ifReport: params.ifReport } }),
  // 替换审批人
  updateAssignee: (params) => API.put('/approvecenter/update_assignee', params),
  // 跳过
  jumpApprove: (params) => API.put(`/approvecenter/jump_task/${params}`),
  // 日期修改
  updateTime: (params) => API.put('/approvecenter/activity_date', params),
  // 获取待调单人列表 - 所有销售包括离职的
  getAllSalesmanList: (params) => API.get(`/config/salesman/all-list/20/${params}`)
};

export const channelAccountManagementApi = {
  // 添加渠道账号
  addChannelAccount: (params) => API.post('/sys_group_permisson/add', params),
  // 刷新渠道对应销售的信息
  refreshAccount: () => API.put('/sys_group_permisson/refresh'),
  // 编辑
  channelAccountUpdate: (params) => API.put('/sys_group_permisson/update', params),
  // 驳回 通过
  channelAccountUpdateStat: (params) => API.put('/sys_group_permisson/update/stat', params)
};

export const businessUnitManagementApi = {
  // 添加
  addBusinessUnit: (params) => API.post('/management/bussiness_unit', params),
  // 编辑
  editBusinessUnit: (params) => API.put('/management/bussiness_unit', params),
  // 删除
  deleteBusinessUnit: (params) => API.delete(`/management/bussiness_unit/${params}`),
  // 对应部门列表
  getDeptList: (params) => API.post('/management/bussiness_unit/dept', params),
  // 导出
  exportBusinessUnit: (params) => API.post('/management/bussiness_unit/excel', params)
};

export const roleManagementApi = {
  // 获取角色列表
  getRoleList: () => API.get('/lead/role-management/role/list'),
  // 获取角色关联员工列表
  getEmployeeList: (params) => API.get(`/lead/role-management/user/list/${params}`),
  // 新增角色员工关联
  addEmployee: (params) => API.post('/lead/role-management/user/add', params),
  // 移除员工角色关联关系
  deleteEmployee: (params) => API.post('/lead/role-management/user/delete', params),
  // 新增角色
  addRole: (params) => API.post('/lead/role-management/role/add', params),
  // 编辑角色
  editRole: (params) => API.put('/lead/role-management/role/update', params),
  // 编辑用户信息
  editEmployee: (params) => API.put('/lead/role-management/user/update', params),
  // 获取产品线及行业列表  manage_product_line | manage_industry
  getConfigureList: (params) => API.get(`/lead/option_config/option/list/${params}`)
};

export const authorityManagementApi = {
  // 获取权限管理页面所有选项列表
  getOptionList: () => API.get('/lead/permission-management/option/list'),
  // 获取权限管理页面所有权限
  getManageList: (roleId) => API.get(`/lead/permission-management/list/${roleId}`),
  // 更新权限管理页面数据
  PostUpdata: (params) => API.post(`/lead/permission-management/role/update`, params)
};

export const cluePoolManagementApi = {
  // 获取线索池列表
  DetailAll: (poolId) => API.get(`/lead/pool-management/pool/details/${poolId}`),
  // 新建线索池
  addCluePool: (params) => API.post(`/lead/pool-management/pool/add`, params),
  // 更新线索池
  cluePoolUpdate: (params) => API.post(`/lead/pool-management/pool/update`, params),
  // 获取所属部门列表
  getDepartList: () => API.get('/lead/pool-management/dept/list')
};

export const clueStaffCircConfigureApi = {
  // 获取大区列表
  getBigAreaList: () => API.get('/lead/option_config/big_area'),
  // 获取区域列表
  getRegionList: ({ bigArea, keyWord }) => API.get(`/lead/option_config/region/${bigArea}?keyWord=${keyWord}`),
  // 获取审核人列表
  getAdminList: (params) => API.get(`/lead/option_config/admin?role=${params.role}&keyWord=${params.keyWord}`),
  // 删除
  reviewerDelete: (params) => API.post('/lead/option_config/sea_distribution/del', params),
  // 添加
  addReviewer: (params) => API.post('/lead/option_config/sea_distribution', params),
  // 修改
  editReviewer: (params) => API.put('/lead/option_config/sea_distribution', params)
};

export const industryManagementApi = {
  // 添加
  addIndustry: (params) => API.post('/management/manage-industry', params),
  // 编辑
  editIndustry: (params) => API.put('/management/manage-industry', params)
};

export const documentViewPermissionApi = {
  // 可查看部门添加
  visibleDeptAdd: (params) => API.post('/management/visible-dept', params),
  // 可查看部门编辑
  visibleDeptEdit: (params) => API.put('/management/visible-dept', params),
  // 可查看部门删除
  deptDelete: (id) => API.delete(`/management/delvisible-dept/${id}`),
  // 可查看用户添加
  visibleUserAdd: (params) => API.post('/management/visible-user', params),
  // 可查看用户编辑
  visibleUserEdit: (params) => API.put('/management/visible-user', params),
  // 可查看用户删除
  userDelete: (id) => API.delete(`/management/del-visible-user/${id}`)
};
